module.exports = __webpack_public_path__ + "img/9788957982747.3d40c67e.jpg";